import { Component, ViewChild, AfterViewInit, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { removeTextChars } from "../utility";

@Component({
  selector: 'll-model-payer-edit',
  templateUrl: './ll-model-payer-edit.component.html',
  styleUrls: ['../cssMain.css']
})

export class LlModelPayerEditComponent {
  
  @ViewChild('mainDiv_ll_model_payer_edit') mainDiv: ElementRef;
  @ViewChild('gridContainer') gridContainer!: ElementRef;

  constructor(
    private LlModelsService: LlModelsService,
  ) {
  }

  bundle = {
    action: '',
    showPayerEdit: false,
    changeCount: 0,
    editUserMsg:'',
    PAYER: [],
    PAYERID:"",
    PAYERNAME: "",
    PAYERPARENT_SYSID:"",
    VENDERNAME: "",
    PAYERELIGIBLEYN: '',
    LIMIT_BILLEDADVANCE_PCT: 0,
    LIMIT_UNBILLEDADVANCE_PCT: 0,
    LIMIT_RESERVES_AMT:0,
    LIMIT_ENV_OVERRIDE_PCT:0,
    parentPayerArray:[],
    text_billedAdvanceRate: {},
    text_unbilledAdvanceRate: {},
    text_reserve: {},
    text_LIMIT_ENV_OVERRIDE_PCT: {},
    eligibleChoices: [],
    ageCapChoices_billed: [],
    ageCapChoices_unbilled: [],
    LIMIT_ENVCALCBUCKET_DAYSChoices: [],
    parentW: 0,
    parentH: 0,
    outlineY: 30,
    outlineX: 10,
    outlineH: 0,
    outlineW:0,
    outlineB: 0,
    spX: 0,
    spY: 0,
    spW: 0,
    spH: 0,
    spB: 0,
    parentGridX:0,
    parentGridW: 200,
  };

  ngOnDestroy() {}

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.setVars()

    setTimeout(() => this.scrollToHighlightedRow(), 800);
  }

  setVars() {

    setTimeout(() => {
      this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
      this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

      
      this.bundle.outlineW = this.bundle.parentW - 20;
      this.bundle.outlineH = this.bundle.parentH - this.bundle.outlineY - 40;

      this.bundle.parentGridX = this.bundle.outlineW - this.bundle.parentGridW - 20

      this.bundle.spY = this.bundle.outlineY + 0;
      this.bundle.spX = this.bundle.outlineX;
      this.bundle.spW = this.bundle.parentGridX - this.bundle.spX - 10;
      this.bundle.spH = this.bundle.outlineH - this.bundle.spY - 20;

     
      this.getData();
    });

  }

  getData() {

    this.LlModelsService.NG_LL_model_AR_payers_target_get(done01, this.bundle);

    function done01(arr, bundle) {

     
      ///const PAYER = arr;

      bundle.PAYER = arr;

      bundle.PAYERID = bundle.PAYER[0].PAYERID;
      bundle.PAYERNAME = bundle.PAYER[0].PAYERNAME;
      ///bundle.PAYERPARENT = bundle.PAYER[0].PAYERPARENT;
      bundle.PAYERPARENT_SYSID = 30;///bundle.PAYER[0].PAYERPARENT_SYSID
      bundle.VENDERNAME = bundle.PAYER[0].VENDERNAME;
      bundle.PAYERELIGIBLEYN = bundle.PAYER[0].PAYERELIGIBLEYN;
      bundle.LIMIT_BILLEDADVANCE_PCT = bundle.PAYER[0].LIMIT_BILLEDADVANCE_PCT;
      bundle.LIMIT_UNBILLEDADVANCE_PCT = bundle.PAYER[0].LIMIT_UNBILLEDADVANCE_PCT;
      bundle.LIMIT_RESERVES_AMT = bundle.PAYER[0].LIMIT_RESERVES_AMT;
      bundle.LIMIT_ENV_OVERRIDE_PCT = bundle.PAYER[0].LIMIT_ENV_OVERRIDE_PCT;
      ////bundle.LIMIT_BILLED_AGECAPDAYS = bundle.PAYER[0].LIMIT_BILLED_AGECAPDAYS;

      console.log(bundle)
      console.log(bundle.PAYER[0].ELIGIBLEYESNO)
      console.log(bundle.PAYER[0].PAYERELIGIBLEYN)

      bundle.parentPayerArray = [
        { payerParent_sysId: 1, realParentName: "Novitas Solutions" },
        { payerParent_sysId: 2, realParentName: "UnitedHealthcare" },
        { payerParent_sysId: 3, realParentName: "Optum" },
        { payerParent_sysId: 4, realParentName: "Humana" },
        { payerParent_sysId: 5, realParentName: "Humana" },
        { payerParent_sysId: 6, realParentName: "Novitas Solutions" },
        { payerParent_sysId: 7, realParentName: "Anthem Blue Cross Blue Shield" },
        { payerParent_sysId: 8, realParentName: "Health Net" },
        { payerParent_sysId: 9, realParentName: "PNC Health Plan" },
        { payerParent_sysId: 10, realParentName: "Maryland Physicians Care" },
        { payerParent_sysId: 11, realParentName: "Cigna Healthcare" },
        { payerParent_sysId: 12, realParentName: "Aetna" },
        { payerParent_sysId: 13, realParentName: "Humana" },
        { payerParent_sysId: 14, realParentName: "Wellpoint" },
        { payerParent_sysId: 15, realParentName: "The Health Plan" },
        { payerParent_sysId: 16, realParentName: "Humana Insurance Company" },
        { payerParent_sysId: 17, realParentName: "UnitedHealthcare" },
        { payerParent_sysId: 18, realParentName: "Maryland Medicaid MCO" },
        { payerParent_sysId: 19, realParentName: "Humana" },
        { payerParent_sysId: 20, realParentName: "CareFirst BlueCross BlueShield" },
        { payerParent_sysId: 21, realParentName: "Humana Insurance Company" },
        { payerParent_sysId: 22, realParentName: "Humana" },
        { payerParent_sysId: 23, realParentName: "Humana" },
        { payerParent_sysId: 24, realParentName: "Medical Mutual of Ohio" },
        { payerParent_sysId: 25, realParentName: "Pay Plus" },
        { payerParent_sysId: 26, realParentName: "Medicare Advantage Plan (via CommuniCare Health Services)" },
        { payerParent_sysId: 27, realParentName: "U.S. Treasury" },
        { payerParent_sysId: 28, realParentName: "Loyale Health" },
        { payerParent_sysId: 29, realParentName: "National Data Corporation" },
        { payerParent_sysId: 30, realParentName: "State of Maryland" },
        { payerParent_sysId: 32, realParentName: "Manage and Net" },
        { payerParent_sysId: 33, realParentName: "Gainwell Technologies" },
        { payerParent_sysId: 34, realParentName: "Ohio Medicaid" },
        { payerParent_sysId: 35, realParentName: "District of Columbia Government" },
        { payerParent_sysId: 36, realParentName: "Loyale Health" },
        { payerParent_sysId: 37, realParentName: "Pay Plus" },
        { payerParent_sysId: 38, realParentName: "Internal Transfer" },
        { payerParent_sysId: 39, realParentName: "Unknown" },
        { payerParent_sysId: 40, realParentName: "Bridgeport Healthcare" }
      ];

      bundle.eligibleChoices.push({ choice: 'Yes', code: "Y", SELECTED: false })
      bundle.eligibleChoices.push({ choice: 'No', code: "N", SELECTED: false })

      bundle.ageCapChoices_billed.push({ choice: '30', code: "30", SELECTED: false })
      bundle.ageCapChoices_billed.push({ choice: '60', code: "60", SELECTED: false })
      bundle.ageCapChoices_billed.push({ choice: '90', code: "90", SELECTED: false })
      bundle.ageCapChoices_billed.push({ choice: '120', code: "120", SELECTED: false })
      bundle.ageCapChoices_billed.push({ choice: '150', code: "150", SELECTED: false })
      bundle.ageCapChoices_billed.push({ choice: '180', code: "180", SELECTED: false })
      bundle.ageCapChoices_billed.push({ choice: 'All', code: "1000", SELECTED: false })

      bundle.ageCapChoices_unbilled.push({ choice: '0', code: "0", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: '30', code: "30", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: '60', code: "60", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: '90', code: "90", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: '120', code: "120", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: '150', code: "150", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: '180', code: "180", SELECTED: false })
      bundle.ageCapChoices_unbilled.push({ choice: 'All', code: "1000", SELECTED: false })

      bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.push({ choice: '30', code: "30", SELECTED: false })
      bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.push({ choice: '60', code: "60", SELECTED: false })
      bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.push({ choice: '90', code: "90", SELECTED: false })
      bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.push({ choice: '120', code: "120", SELECTED: false })
      bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.push({ choice: '150', code: "150", SELECTED: false })
      bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.push({ choice: '180', code: "180", SELECTED: false })


      done01(bundle)

      function done01(bundle) {

        for (let i = 0; i < bundle.eligibleChoices.length; i++) {

          if (bundle.PAYER[0].PAYERELIGIBLEYN == bundle.eligibleChoices[i].code) {
            bundle.eligibleChoices[i].SELECTED = true;
            done02(bundle)
          }
        }
      }
      function done02(bundle) {
        for (let i = 0; i < bundle.ageCapChoices_billed.length; i++) {

          if (bundle.PAYER[0].LIMIT_BILLED_AGECAPDAYS == bundle.ageCapChoices_billed[i].code) {

            setTimeout(() => {
              bundle.ageCapChoices_billed[i].SELECTED = true;
              done03(bundle)
            });
          }
        }        
      }

      function done03(bundle) {
        for (let j = 0; j < bundle.ageCapChoices_unbilled.length; j++) {

          if (bundle.PAYER[0].LIMIT_UNBILLED_AGECAPDAYS == bundle.ageCapChoices_unbilled[j].code) {

            bundle.ageCapChoices_unbilled[j].SELECTED = true;

            setTimeout(() => {

              ///console.log(bundle.LIMIT_UNBILLED_AGECAPDAYS)

              //bundle.ageCapChoices_unbilled[j].SELECTED = true;
              done04(bundle)
            });
          }

        }
      }

      function done04(bundle) {

        ///console.log(bundle.LIMIT_ENVCALCBUCKET_DAYS)

        for (let i = 0; i < bundle.LIMIT_ENVCALCBUCKET_DAYSChoices.length; i++) {
          if (bundle.PAYER[0].LIMIT_ENVCALCBUCKET_DAYS == bundle.LIMIT_ENVCALCBUCKET_DAYSChoices[i].code) {
            setTimeout(() => {
              bundle.LIMIT_ENVCALCBUCKET_DAYSChoices[i].SELECTED = true;
              done05(bundle)
            });
          }
        }
      }

      function done05(bundle) {
        setTimeout(() => {
          bundle.showPayerEdit = true
        });
      }

    }
  }

  selectAgeCap(event, from) {

    console.log(from)
    console.log(event.target.value)

    if (from == 'LIMIT_BILLED_AGECAPDAYS') {
      this.bundle.PAYER[0].LIMIT_BILLED_AGECAPDAYS = event.target.value;
    } else if (from == 'LIMIT_UNBILLED_AGECAPDAYS') { 
      this.bundle.PAYER[0].LIMIT_UNBILLED_AGECAPDAYS = event.target.value;
    } else if (from == 'PAYERELIGIBLEYN') {
      this.bundle.PAYER[0].PAYERELIGIBLEYN = event.target.value;
    }
  }

  selectLIMIT_ENVCALCBUCKET_DAYS(event) {
    this.bundle.PAYER[0].LIMIT_ENVCALCBUCKET_DAYS = event.target.value
  }

  selectPayerParent(payer: any) {
    //this.bundle.PAYERPARENT = payer.realParentName;
    this.bundle.PAYERPARENT_SYSID = payer.payerParent_sysId;
    console.log('Selected Payer Parent:', payer.realParentName, 'SYSID:', payer.payerParent_sysId);
    this.scrollToHighlightedRow();
  }

  private scrollToHighlightedRow() {
    if (this.gridContainer && this.bundle.PAYERPARENT_SYSID) {
      const gridElement = this.gridContainer.nativeElement;
      const highlightedRow = gridElement.querySelector(`[data-sysid="${this.bundle.PAYERPARENT_SYSID}"]`);
      if (highlightedRow) {
        highlightedRow.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }

  onKeyUp(event, from) {

    let val = removeTextChars(event.target.value)

    console.log(from)
    console.log(val)

    if (from == 'LIMIT_BILLEDADVANCE_PCT') {
      this.bundle.PAYER[0].LIMIT_BILLEDADVANCE_PCT = val;
    } else if (from == 'LIMIT_UNBILLEDADVANCE_PCT') {
      this.bundle.PAYER[0].LIMIT_UNBILLEDADVANCE_PCT = val;
    } else if (from == 'LIMIT_RESERVES_AMT') {
      this.bundle.PAYER[0].LIMIT_RESERVES_AMT = val;
    }

  }

  onInput(event, from) {
    this.onKeyUp(event, from)
  }

  submitChange() {
    this.bundle.editUserMsg = "";

    //this.bundle.PAYER[0].LIMIT_BILLEDADVANCE_PCT = this.text_billedAdvanceRate.val()
    //this.bundle.PAYER[0].LIMIT_UNBILLEDADVANCE_PCT = this.text_unbilledAdvanceRate.val()
    //this.bundle.PAYER[0].LIMIT_RESERVES_AMT = this.text_reserve.val()
    //this.bundle.PAYER[0].LIMIT_ENV_OVERRIDE_PCT = this.text_LIMIT_ENV_OVERRIDE_PCT.val()

    if (this.bundle.PAYER[0].LIMIT_BILLEDADVANCE_PCT != "" && this.bundle.PAYER[0].LIMIT_UNBILLEDADVANCE_PCT != '') {
      this.LlModelsService.NG_LL_model_AR_payers_target_edit(this.returnedMessage,this.bundle.PAYER, this.bundle)
    }
  }

  returnedMessage(msg, bundle) {

    if (msg != '') {
      bundle.editUserMsg = msg
    }
  }


};
